import { gql } from "types";

export const GET_NOTIFICATIONS = gql(/* GraphQL */ `
  query GetNotifications($pagination: Pagination, $filters: FiltersExpression) {
    notifications(pagination: $pagination, filters: $filters) {
      count
      list {
        id
        createdAt
        type
        data
        readAt
      }
    }
  }
`);

export const GET_UNREAD_NOTIFICATIONS_COUNT = gql(/* GraphQL */ `
  query GetUnreadNotificationsCount {
    notifications(
      filters: {
        operator: AND
        filters: [{ op: IS_NULL, field: "read_at", values: [] }]
      }
    ) {
      count
    }
  }
`);
